import clsx from 'clsx'
import { BuildingIcon, ContractIcon, LogHistory, MeterIcon, StaffIcon, SummaryIcon, Invoice, Price } from '../../assets/icons'
import { PageHeader } from '../../components'
import { IconWrap } from '../../components/IconWrap'
import styles from './index.module.scss'
import headerImg from '../../assets/images/homeHeader.png'
import { Col, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useGetAllSummary } from '../../hooks/query/summary'
import { useTranslation } from 'react-i18next'
import { LanguageEnum } from '../../until/constant'
export const Home = () => {
  const navigate = useNavigate()
  const { data } = useGetAllSummary()
  const userType = localStorage.getItem('user_type') || ''
  const { t,i18n } = useTranslation()
  
  return (
    <div className={clsx(styles.home)}>
      <PageHeader backgroundImage={headerImg} height="200px">
        <div className={clsx(styles.home__header)}>
          <div className={clsx(styles.home__header__item)}>
            <span>{t('home.numOfBuilding')}</span>
            <span>{data?.data.total_building}</span>
          </div>
          <div className={clsx(styles.home__header__item)}>
            <span>{t('home.numOfStaff')}</span>
            <span>{data?.data.total_staff}</span>
          </div>
          <div className={clsx(styles.home__header__item)}>
            <span>{t('home.numOfMeters')}</span>
            <span>{data?.data.total_meter}</span>
          </div>
        </div>
      </PageHeader>
      <div className={clsx(styles.home__main)}>
        {
          userType === '1' ?
            <Row gutter={[40, 40]} className={clsx(styles.home__main__row)}>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('staff')}>
                  <IconWrap icon={<StaffIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.staff')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('building')}>
                  <IconWrap icon={<BuildingIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.building')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('meter')}>
                  <IconWrap icon={<MeterIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.meter')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('summary')}>
                  <IconWrap icon={<SummaryIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.summary')}</p>
                </div>
              </Col>

              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('history')}>
                  <IconWrap icon={<LogHistory />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.history')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('contractor')}>
                  <IconWrap icon={<ContractIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.contractor')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item,  {[styles.home__item_manager]: i18n.language === LanguageEnum.ENGLISH})} onClick={() => navigate('price-manager')}>
                  <IconWrap icon={<Price />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.priceManager')}</p>
                </div>
              </Col>

              <Col>
                <div className={clsx(styles.home__item,  {[styles.home__item_manager]: i18n.language === LanguageEnum.ENGLISH})} onClick={() => navigate('invoice-manager')}>
                  <IconWrap icon={<Invoice />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.invoiceManager')}</p>
                </div>
              </Col>

            </Row>
            :
            <Row gutter={[40, 40]} className={clsx(styles.home__main__row)}>
              <Col>
                <div className={clsx(styles.home__item, styles.home__item_manager)} onClick={() => navigate('staff')}>
                  <IconWrap icon={<StaffIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.staff')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('building')}>
                  <IconWrap icon={<BuildingIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.building')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('meter')}>
                  <IconWrap icon={<MeterIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.meter')}</p>
                </div>
              </Col>

              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('summary')}>
                  <IconWrap icon={<SummaryIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.summary')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('contractor')}>
                  <IconWrap icon={<ContractIcon />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.contractor')}</p>
                </div>
              </Col>
              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('price-manager')}>
                  <IconWrap icon={<Price />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.priceManager')}</p>
                </div>
              </Col>

              <Col>
                <div className={clsx(styles.home__item)} onClick={() => navigate('invoice-manager')}>
                  <IconWrap icon={<Invoice />} className={clsx(styles.home__item__icon)} />
                  <p>{t('header.invoiceManager')}</p>
                </div>
              </Col>
            </Row>
        }
      </div>
    </div>
  )
}
